document.addEventListener('DOMContentLoaded', () => {
 
    let roomsSliderCopy = document.querySelectorAll('.rooms-slider_copy');
	if(roomsSliderCopy.length > 0){
		const roomSliderCopy = new Swiper('.rooms-slider_copy', {
			loop: true,
			effect: "fade",
			speed: 800,
			fadeEffect: {
				"crossFade": true
			},
			navigation: {
				nextEl: '.rooms-next',
				prevEl: '.rooms-prev',
			}
		});

		const roomSliderImages = new Swiper('.rooms-slider_images', {
			allowTouchMove: false,
			loop: true,
			effect: "fade",
			speed: 800,
			fadeEffect: {
				"crossFade": true
			},
		});

		roomSliderCopy.controller.control = roomSliderImages;
		roomSliderImages.controller.control = roomSliderCopy;
	};

	const overviewSlider = new Swiper('.overview-slider', {
		rewind: true,
		effect: "fade",
		speed: 800,
		fadeEffect: {
			"crossFade": true
		},
		navigation: {
			nextEl: '.overview-next',
			prevEl: '.overview-prev',
		}
	});

	const gallerySwiper = new Swiper('.gallery-swiper', {
		slidesPerView: 1,
		rewind: true,
		effect: "fade",
		speed: 800,
		fadeEffect: {
			"crossFade": true
		},
		navigation: {
			nextEl: '.gallery-next',
			prevEl: '.gallery-prev',
		}
	});

	const sliderSwiper = new Swiper('.slider-swiper', {
		slidesPerView: 1,
		effect: "fade",

		fadeEffect: {
			"crossFade": true
		},
		loop: true,
		navigation: {
			nextEl: '.slider-next',
			prevEl: '.slider-prev',
		}
	});

	const heroSwiper = new Swiper('.hero-swiper', {
		slidesPerView: 1,
		loop: true,
		autoplay: {
			delay: 4000,
		},
		speed: 800,
		effect: "fade",
		fadeEffect: {
			"crossFade": true
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
			renderBullet: function (index, className) {
				return `<span class="swiper-pagination-bullet">${index + 1}</span>`;
			}
		}
	});

	let specialsCopy = document.querySelectorAll('.specials-copy');
	if(specialsCopy.length > 0){
		const specialCopy = new Swiper('.specials-copy', {
			loop: true,
			effect: "fade",
			speed: 800,
			fadeEffect: {
				"crossFade": true
			},
			navigation: {
				nextEl: '.special-next',
				prevEl: '.special-prev',
			}
		});

		const specialImages = new Swiper('.specials-images', {
			allowTouchMove: false,
			loop: true,
			effect: "fade",
			speed: 800,
			fadeEffect: {
				"crossFade": true
			},
		});

		specialCopy.controller.control = specialImages;
		specialImages.controller.control = specialCopy;
	};

});